import { render, staticRenderFns } from "./FormDaiLyTinh.vue?vue&type=template&id=be5499bc&scoped=true&"
import script from "./FormDaiLyTinh.vue?vue&type=script&lang=js&"
export * from "./FormDaiLyTinh.vue?vue&type=script&lang=js&"
import style0 from "./FormDaiLyTinh.vue?vue&type=style&index=0&id=be5499bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5499bc",
  null
  
)

export default component.exports